export const environment = "dev";
export const workflow_path = "/workflow"
export const mdm_path = "/mdm"
export const baseURL =
  environment == "prod"
    ? `https://cygnusdatalake.azurewebsites.net/2/api/${environment}`
    : `https://cygnusdatalake.azurewebsites.net/2/api`;
export const syncfusionDocEditorServiceUrl = "https://document.syncfusion.com/web-services/docx-editor/api/documenteditor/";
